/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeAccordion,
  BaSeLoading,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useAnalysisController } from '../../../../../hooks/controllers/analysis-controller';
import { useChatService } from '../../../../../hooks/services/chat-service';
import {
  AlignTitle,
  Container,
  ContainerAlignColumn,
  Content,
  ContentRowAccordion,
} from './answer-candidate-detail-style';
import Legenda from './response-web-chat/legenda/legenta';
import Summary from './response-web-chat/summary/summary';
import BoxIterations from './response-web-chat/iterations/box-iterations';

function AnswersCandidateDetail({
  question,
  answer,
  setDisabledIndex,
  idResposta,
  hasComparative,
  notasRespostas,
  numberQuestion,
  id,
}) {
  const { getAnalysisDetail } = useAnalysisController();
  const { getIterations } = useChatService();

  const [detail, setDetail] = React.useState();
  const [iterations, setIterations] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const wordCount = answer
    .replace(/[.,!?]/g, '')
    .split(/\s+/)
    .filter(Boolean).length;

  React.useEffect(() => {
    if (!hasComparative) return;

    setDisabledIndex(true);
    getAnalysisDetail(idResposta)
      .then((response) => {
        setDetail(response);
      })
      .catch((error) => {
        console.log(error);
        setDetail([]);
      })
      .finally(() => {
        setDisabledIndex(false);
      });
  }, [idResposta, getAnalysisDetail, hasComparative, setDisabledIndex]);

  const getIdInterview = React.useCallback(async () => {
    try {
      setLoading(true);
      if (notasRespostas.hasWebChat) {
        const iterations = await getIterations({
          id,
          question: numberQuestion,
        });

        if (iterations !== undefined) {
          setIterations(iterations);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }, [getIterations, id, notasRespostas.hasWebChat, numberQuestion]);

  React.useEffect(() => {
    getIdInterview();
  }, [getIdInterview]);

  return (
    <Container>
      {notasRespostas.hasWebChat && <Legenda />}
      {!notasRespostas.hasWebChat ? (
        <div>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae10}>
            {question}
          </BaSeParagraph>
          <div>
            <BaSeParagraph>{answer}</BaSeParagraph>
          </div>
          <div>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              {wordCount} palavras digitadas.
            </BaSeParagraph>
          </div>
        </div>
      ) : (
        <BaSeAccordion
          backgroundContentColor="#f5f7fa"
          backgroundTitleColor="#ffffff"
          borderTitleColor="#f5f7fa"
          startOpen={iterations?.iterations?.length > 0 ? [0] : undefined}
          options={[
            {
              title: question,
              content: loading ? (
                <BaSeLoading
                  description=""
                  lightMode="default"
                  shadowLevel={0}
                  spinnerColor=""
                  spinnerSize={24}
                  text="Carregando…"
                  textColor=""
                />
              ) : (
                <BoxIterations iterations={iterations?.iterations} />
              ),
            },
          ]}
          radius={8}
          titleColor="#617385"
        />
      )}

      {notasRespostas.hasWebChat && iterations?.summary && (
        <Summary
          summary={iterations?.summary}
          loading={loading}
          summaryLength={wordCount}
        />
      )}

      {hasComparative && detail && (
        <ContainerAlignColumn>
          <AlignTitle>
            <BaSeParagraph>PONTUAÇÃO DAS CCEs</BaSeParagraph>
          </AlignTitle>
          <div></div>
          <ContainerAlignColumn>
            <BaSeAccordion
              backgroundContentColor="#f5f7fa"
              backgroundTitleColor="#ffffff"
              borderTitleColor="#f5f7fa"
              multipleOpen
              options={detail.items?.map((it, index) => {
                return {
                  content: (
                    <Content key={it.order}>
                      <ContentRowAccordion>
                        <BaSeParagraph isBold>Empretec:</BaSeParagraph>
                        <BaSeParagraph>{it.score}</BaSeParagraph>
                      </ContentRowAccordion>

                      <ContentRowAccordion>
                        <BaSeParagraph>
                          <strong>Justificativa: </strong>
                          {it.comment}
                        </BaSeParagraph>
                      </ContentRowAccordion>
                      <ContentRowAccordion>
                        <BaSeParagraph isBold>Comparativa:</BaSeParagraph>
                        <BaSeParagraph>{it.comparativeScore}</BaSeParagraph>
                      </ContentRowAccordion>
                      <ContentRowAccordion>
                        <BaSeParagraph>
                          <strong>Justificativa: </strong>
                          {it.comparativeComment}
                        </BaSeParagraph>
                      </ContentRowAccordion>
                    </Content>
                  ),
                  title: it.cceDescription,
                };
              })}
              radius={8}
              titleColor="#617385"
            />
          </ContainerAlignColumn>
        </ContainerAlignColumn>
      )}
    </Container>
  );
}

export default AnswersCandidateDetail;
